import { configs } from './configs';

export function environment() {
  if (configs.hasOwnProperty(window.location.hostname)) {
    return configs[window.location.hostname];
  } else {
    return configs.empty;
  }
}
